function Description({description}){
  return(
    <div style={{color:'var(--color-secondary)'}} className="mb-5">{description}</div>
  );
}

export default Description;
